<!-- RadioButtonGroup.vue -->
<script lang="ts" setup>
import { LayoutOrientation } from '../../Enums/UiEnums';
import RadioButtonInput from '../RadioButtonInput.vue';
import { IRadioButtonItem } from './RadioButtonGroupModels';

    const props = defineProps<{
        modelValue?: any,
        items: IRadioButtonItem[],
        layout?: LayoutOrientation,
    }>();

    const emits = defineEmits(["update:model-value"]);

    function emitValue(val: any)
    {
        emits("update:model-value", val);
    }
</script>

<template>
    <template v-for="item in items.filter(ele => !ele.hidden)">
        <RadioButtonInput 
            :modelValue="props.modelValue"
            @update:modelValue="val => emitValue(val)"
            :layout="props.layout"
            :value="item.value"
            :disabled="item.disabled">
            {{ item.text }}
        </RadioButtonInput>
    </template>
</template>